module.exports = __webpack_public_path__ + "static/about_system_tak_nie_czas-26cefcab2ad05d80605830708c535011.png";